import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const authConfig = (token) => ({
  headers: { authorization: `Bearer ${token}` },
});

const multipartConfig = (token) => ({
  headers: {
    authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
  },
});

export const DOCUMENT_TYPE_OPTIONS = [
  "Terms & Conditions",
  "Product Brochure",
  "Benefit Illustration",
];

export const MAX_POLICY_PDF_MB = 20;

export function formatDetailDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const getGeneralDocuments = (token, params = {}) =>
  axios.get(`${BACKEND_URL}api/policy-general-documents`, {
    ...authConfig(token),
    params,
  });

const getGeneralDocument = (token, id) =>
  axios.get(`${BACKEND_URL}api/policy-general-documents/${id}`, authConfig(token));

const uploadGeneral = (token, formData) =>
  axios.post(
    `${BACKEND_URL}api/policy-general-documents`,
    formData,
    multipartConfig(token)
  );

const updateGeneral = (token, id, formData) =>
  axios.put(
    `${BACKEND_URL}api/policy-general-documents/${id}`,
    formData,
    multipartConfig(token)
  );

const deleteGeneral = (token, id) =>
  axios.delete(
    `${BACKEND_URL}api/policy-general-documents/${id}`,
    authConfig(token)
  );

const downloadGeneral = (token, id) =>
  axios.get(`${BACKEND_URL}api/policy-general-documents/${id}/download`, {
    ...authConfig(token),
    responseType: "blob",
  });

const getProductTypes = (token) =>
  axios.get(`${BACKEND_URL}api/policy-general-documents/product-types`, {
    ...authConfig(token),
  });

const getCustomerDocuments = (token, params = {}) =>
  axios.get(`${BACKEND_URL}api/policy-customer-documents`, {
    ...authConfig(token),
    params,
  });

const getCustomerDocument = (token, id) =>
  axios.get(`${BACKEND_URL}api/policy-customer-documents/${id}`, authConfig(token));

const uploadCustomer = (token, formData) =>
  axios.post(
    `${BACKEND_URL}api/policy-customer-documents`,
    formData,
    multipartConfig(token)
  );

const updateCustomer = (token, id, formData) =>
  axios.put(
    `${BACKEND_URL}api/policy-customer-documents/${id}`,
    formData,
    multipartConfig(token)
  );

const deleteCustomer = (token, id) =>
  axios.delete(
    `${BACKEND_URL}api/policy-customer-documents/${id}`,
    authConfig(token)
  );

const downloadCustomer = (token, id) =>
  axios.get(`${BACKEND_URL}api/policy-customer-documents/${id}/download`, {
    ...authConfig(token),
    responseType: "blob",
  });

const policyDocumentService = {
  getGeneralDocuments,
  getGeneralDocument,
  uploadGeneral,
  updateGeneral,
  deleteGeneral,
  downloadGeneral,
  getProductTypes,
  getCustomerDocuments,
  getCustomerDocument,
  uploadCustomer,
  updateCustomer,
  deleteCustomer,
  downloadCustomer,
};

export default policyDocumentService;
